import { Select } from "antd";
import { Link } from "react-router";
import SimpleTablePage from "../common/SimpleTablePage";

const yesNo = (value) => (value ? "Sì" : "No");
const columns = [
  { title: "ID", key: "id", dataIndex: "id", width: 80, sorter: true },
  {
    title: "Nome",
    key: "name",
    dataIndex: "name",
    width: 240,
    ellipsis: true,
    sorter: true,
    render: (name, record) => (
      <Link to={`${record.id}`} onClick={(event) => event.stopPropagation()}>
        {name}
      </Link>
    ),
  },
  {
    title: "Includi nei documenti HSE",
    key: "includeInHseDocuments",
    dataIndex: "includeInHseDocuments",
    width: 220,
    sorter: true,
    render: yesNo,
  },
  {
    title: "Richiede scadenza",
    key: "requiresDueDate",
    dataIndex: "requiresDueDate",
    width: 180,
    sorter: true,
    render: yesNo,
  },
];
const filterItems = columns.slice(2).map((column) => ({
  name: column.key,
  label: column.title,
  readableValue: (value) => (value === "true" ? "Sì" : "No"),
  formItem: {
    children: (
      <Select
        allowClear
        options={[
          { label: "Sì", value: "true" },
          { label: "No", value: "false" },
        ]}
      />
    ),
  },
}));

export default function Tags() {
  return <SimpleTablePage title="Tag" resource="tag" columns={columns} filterItems={filterItems} />;
}
